<script setup lang="ts">
interface TechItem {
  name: string
  icon: string
}

interface TechCategory {
  name: string
  items: TechItem[]
}

const { data: techDoc } = await useAsyncData('tech-stack', () =>
  queryCollection('techStack').first()
)

const categories = computed(() => ((techDoc.value as { categories?: TechCategory[] } | null)?.categories ?? []) as TechCategory[])
</script>

<template>
  <section
    id="tech-stack"
    class="py-12"
  >
    <h2 class="text-xs font-semibold uppercase tracking-widest text-muted mb-6">
      Tech Stack
    </h2>

    <div class="space-y-6">
      <div
        v-for="category in categories"
        :key="category.name"
      >
        <p class="text-sm text-muted mb-3">
          {{ category.name }}
        </p>
        <div class="flex flex-wrap gap-2">
          <div
            v-for="item in category.items"
            :key="item.name"
            class="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-default bg-elevated text-sm text-highlighted transition-colors hover:border-zinc-600 cursor-default"
          >
            <UIcon
              :name="item.icon"
              class="size-3.5 shrink-0"
            />
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
